var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMagic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.28125 8.875C0.8125 9.05208 0.5 9.5 0.5 10C0.5 10.5 0.8125 10.9479 1.28125 11.125L7.16667 13.3333L9.375 19.2188C9.55208 19.6875 10 20 10.5 20C11 20 11.4479 19.6875 11.625 19.2188L13.8333 13.3333L19.7187 11.125C20.1875 10.9479 20.5 10.5 20.5 10C20.5 9.5 20.1875 9.05208 19.7187 8.875L13.8333 6.66667L11.625 0.78125C11.4479 0.3125 11 0 10.5 0C10 0 9.55208 0.3125 9.375 0.78125L7.16667 6.66667L1.28125 8.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMagic);
export default __webpack_public_path__ + "static/media/IconMagic.3a8d719dbff5c5703d4af1e3a158e1f4.svg";
export { ForwardRef as ReactComponent };